const connection = {
  config: () => {
    return {
      conn: process.env.REACT_APP_BACKEND_URL
      // conn: 'http://172.20.0.4:5000/api/'
    }
  }
}

module.exports = connection
